import { render, staticRenderFns } from "./ExaminationDetailAdd.vue?vue&type=template&id=7a6f1a6f&scoped=true"
import script from "./ExaminationDetailAdd.vue?vue&type=script&lang=js"
export * from "./ExaminationDetailAdd.vue?vue&type=script&lang=js"
import style0 from "./ExaminationDetailAdd.vue?vue&type=style&index=0&id=7a6f1a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f1a6f",
  null
  
)

export default component.exports